import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import { lazy } from 'react';
import { PERMISSIONS } from '@/api/permissions';
import { paths } from '@/routes/paths';
import { RequirePermission } from '@/routes/guards';
import type { ModuleManifest } from './manifest';

const MyOrganizationPage = lazy(() => import('@/features/myOrganization/MyOrganizationPage'));

/**
 * The tenant's own record.
 *
 * It lives in the top bar's organization menu, not in the apps grid (owner's
 * call, 2026-09-27): it is one page about who you are, the same category as
 * Profile and Settings, and a one-page tile would make the grid lie about what
 * a module is. It is written as a manifest anyway, so it is gated by the same
 * `viewerMatches` and guarded by the same `RequireModule` as any module — and
 * the day licences, branding and billing group under it, promoting it to a
 * tile is `surface` and a `sections` list, not a rewrite.
 */
export const myOrganizationModule: ModuleManifest = {
  key: 'myOrganization',
  titleKey: 'modules.myOrganization.title',
  descriptionKey: 'modules.myOrganization.description',
  icon: BusinessCenterRoundedIcon,
  prefix: paths.myOrganization,
  surface: 'organizationMenu',
  // Tenant-only, and this is the entry that proved the audience gate was
  // drawn but never enforced: a platform admin holds `*` and could open
  // /my-organization by URL until `RequireModule` landed.
  audience: 'tenant',
  anyOf: [PERMISSIONS.ORGANIZATION_READ],
  // No sidebar: one page, full width, like the shell's own pages.
  sections: [],
  routes: [
    {
      element: <RequirePermission permission={[PERMISSIONS.ORGANIZATION_READ]} />,
      children: [{ path: paths.myOrganization, element: <MyOrganizationPage /> }],
    },
  ],
  landing: () => paths.myOrganization,
};
